import { render, staticRenderFns } from "./ModalFrecuentQuestions.vue?vue&type=template&id=26839d00&"
import script from "./ModalFrecuentQuestions.vue?vue&type=script&lang=js&"
export * from "./ModalFrecuentQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports